export const normalizeLanguageCode = (value: string | undefined | null): string | undefined => {
  const trimmed = value?.trim() ?? '';
  if (!trimmed) {
    return undefined;
  }
  return trimmed.length <= 10 ? trimmed : undefined;
};
